import BackButton from 'components/layouts/BackButton';
import React from 'react';
import { MarketOverview } from 'react-ts-tradingview-widgets';

const Stocks = () => {
  return (
    <div>
      <BackButton text="stocks" />
      <br />
      <MarketOverview width="100%" />
    </div>
  );
};

export default Stocks;
